import React from 'react';
import useDataAtrato from '../../hooks/useDataAtrato';
import './AtratoPayment.css';

const AtratoPayment = () => {
  return (
    <div
      id="higslide-div-atrato-info"
      data-ordernumber={useDataAtrato().orderNumber}
      data-orderid={useDataAtrato().orderId}
      data-idcommerce={useDataAtrato().idCommerce}
      data-price={useDataAtrato().price}
      data-product={useDataAtrato().product}
      data-email={useDataAtrato().email}
      data-name={useDataAtrato().name}
      data-phone={useDataAtrato().phone}
      data-plataform={useDataAtrato().platform}
      data-type={useDataAtrato().type}
      data-urlhost={useDataAtrato().host}
      data-style="dark"
      data-linkcolor="black"
      data-version="2.0"
    />
  );
};

export default AtratoPayment;
